import ResourceCategoryLibrary from "../components/ResourceCategoryLibrary/ResourceCategoryLibrary";
import { WellKnownLearningMaterialCategories } from "UIPalette/LearningMaterials/wellKnownLearningMaterials";
import { useTranslation } from "react-i18next";
import { ResourceViewer } from "../components/ResourceViewer/ResourceViewer";

export const ViewNewsletters = () => <ResourceViewer pageTitle="pageTitle.resources.newsletters.article" />;

export const Newsletters = () => {
  const { t } = useTranslation();

  return (
    <ResourceCategoryLibrary
      category={WellKnownLearningMaterialCategories.newsletters}
      hideInterests={true}
      pageTitle={t("pageTitle.resources.newsletters.home")}
    />
  );
};
